import { TThunkAction } from '../../types/redux';
import { ISubmitProps } from '../../containers/FormContainer/types/internal';
import { mapAnswersState } from './utils/mapAnswersState';
import { TFormSubmitResult, TMappedAnswersState } from './types';
import {
  fetchCreateMessage,
  ICreateMessageResponse200,
  ICreateMessageResponse400,
} from '../../repositories/demand/v4/create-message';
import { createRequestPayload } from './utils/createRequestPayload';
import { prepareErrorMeta } from './utils/prepareErrorMeta';
import { getErrorMessageFromError } from './utils/getErrorMessageFromError';

export const submitForm = (props: ISubmitProps): TThunkAction<Promise<TFormSubmitResult | Error>> => async (
  dispatch,
  getState,
  { httpApi, logger },
) => {
  const state: TMappedAnswersState = mapAnswersState(props);
  try {
    const createMessageData = await fetchCreateMessage<ICreateMessageResponse200, ICreateMessageResponse400>({
      httpApi,
      parameters: createRequestPayload(state),
    });

    if (createMessageData.statusCode === 200) {
      return createMessageData.response;
    }

    throw createMessageData.response;
  } catch (error) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const meta = prepareErrorMeta({ state, error }) as any;

    logger.error('Unable to send demand form', meta);

    const errorMessage = getErrorMessageFromError(error);

    return new Error(errorMessage);
  }
};
